import React from 'react';
import { AlertCircle } from 'lucide-react';

const SubscriptionRequired = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '40px',
        maxWidth: '500px',
        textAlign: 'center'
      }}>
        <AlertCircle 
          size={64} 
          color="#ff4d4f" 
          style={{ margin: '0 auto 20px' }}
        />
        
        <h1 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          marginBottom: '16px',
          color: '#262626'
        }}>
          Subscription Required
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#595959',
          marginBottom: '24px',
          lineHeight: '1.6'
        }}>
          A valid subscription is required to access this module. 
          Please purchase a subscription to continue.
        </p>
        
        <div style={{
          backgroundColor: '#f0f0f0',
          padding: '16px',
          borderRadius: '4px',
          marginBottom: '24px'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#8c8c8c',
            margin: 0
          }}>
            Need help? Contact us at:
          </p>
          <a 
            href="mailto:support@infoedmedia.com"
            style={{
              fontSize: '16px',
              color: '#1890ff',
              fontWeight: '500',
              textDecoration: 'none'
            }}
          >
            support@infoedmedia.com
          </a>
        </div>
        
        <a 
          href="https://infoedmedia.com/shopping_cart/"
          style={{
            display: 'inline-block',
            padding: '12px 32px',
            backgroundColor: '#1890ff',
            color: 'white',
            borderRadius: '4px',
            textDecoration: 'none',
            fontWeight: '500',
            fontSize: '16px'
          }}
        >
          Purchase Subscription
        </a>
      </div>
    </div>
  );
};

export default SubscriptionRequired;